
export const ActionType = {
    SetSelectedTree: "SET_SELECTED_TREE",
}

export const LOCAL_STORAGE_KEY = "_customer_state"

const YokohamaDataReducer = (state, action) => {

    switch(action.type) {
        case ActionType.SetSelectedTree:
            return {...state, selectedTree: action.value}
        default:
            return state
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        ...state,
        //
        selectedTree: null,
    }))

    return state
}

export default YokohamaDataReducer
